// Mock data for NIVA Digital website

export const mockServices = [
  {
    id: 'ai-services',
    title: 'AI Services',
    slug: 'ai-services',
    route: '/ai-services',
    shortDescription: 'Building AI from scratch for startups, integrating AI into legacy enterprise systems, and augmenting existing SaaS products with intelligent capabilities.',
    icon: 'Brain',
    features: [
      'Greenfield AI for startups, zero to production',
      'AI integration into legacy enterprise stacks',
      'SaaS product augmentation with AI features',
      'Strategy, data, models and autonomous workflows'
    ],
    benefits: [
      'Faster time to market',
      'Production-ready AI systems',
      'Seamless legacy integration',
      'Intelligent product capabilities'
    ]
  },
  {
    id: 'offshore-pods',
    title: 'PODs',
    slug: 'offshore-pods',
    shortDescription: 'Deploy world class AI-enabled engineering talent',
    icon: 'Users',
    features: [
      'Pre-assembled Multi-disciplinary Teams',
      'Data Engineering Pods',
      'Infrastructure & DevOps Pods',
      'AI Enabled Engineering Pods',
      'Flexible Engagement Models',
      'Seamless Team Integration'
    ],
    benefits: [
      'Save up to 60% on operational costs',
      'Access to top-tier talent',
      'Rapid team scaling',
      'Round-the-clock productivity'
    ]
  },
  {
    id: 'cloud-managed',
    title: 'Cloud Infrastructure Services',
    slug: 'cloud-managed',
    shortDescription: 'End-to-end cloud infrastructure management, DevOps, and CloudOps solutions',
    icon: 'Cloud',
    features: [
      'Cloud Migration & Optimization',
      'Infrastructure as Code (IaC)',
      'CI/CD Pipeline Implementation',
      '24/7 Monitoring & Support',
      'Security & Compliance',
      'Cost Optimization'
    ],
    benefits: [
      '99.9% uptime guarantee',
      'Reduce cloud costs by 30-50%',
      'Faster deployment cycles',
      'Enterprise-grade security'
    ]
  },
  {
    id: 'bot-consulting',
    title: 'GCC Consulting Services',
    slug: 'bot-consulting',
    shortDescription: 'Build, Operate, Transfer high-performance Global Capability Centres',
    icon: 'Building2',
    features: [
      'Product Engineering Teams',
      'Technical Support Centers',
      'Sales & Marketing Functions',
      'Finance & Operations Support',
      'Culture-First Hiring',
      'SEZ Benefits & Cost Optimization'
    ],
    benefits: [
      '40-60% cost savings',
      'Proven Build-Operate-Transfer model',
      '24/7 global coverage',
      '500+ tech jobs created'
    ]
  }
];

export const mockPodPackages = [
  {
    name: 'Gold',
    type: 'premium',
    description: 'Dedicated Plug & Play Team',
    coreTeam: [
      { role: 'Sr AI-Enabled Engineer', included: true },
      { role: 'DevOps Engineer', included: true },
      { role: 'CloudOps Engineer', included: true },
      { role: 'Associate Engineer', included: true },
      { role: 'Project Coordinator & Strategist', included: true }
    ],
    specialists: [
      { role: 'Cloud Architect', hours: '8 Hours/Month free, then $/hr' },
      { role: 'Engineer of your Choice', hours: '8 Hours/Month free, then $/hr' }
    ],
    pricing: 'Contact Us'
  },
  {
    name: 'Silver',
    type: 'standard',
    description: 'Dedicated Plug & Play Team',
    coreTeam: [
      { role: 'Sr AI-Enabled Engineer', included: true },
      { role: 'DevOps Engineer', included: true },
      { role: 'CloudOps Engineer', included: false },
      { role: 'Associate Engineer', included: true },
      { role: 'Project Coordinator & Strategist', included: true }
    ],
    specialists: [
      { role: 'Cloud Architect', hours: '4 Hours/Month free, then $/hr' },
      { role: 'Engineer of your Choice', hours: 'Not included' }
    ],
    pricing: 'Contact Us'
  },
  {
    name: 'Ala Carte',
    type: 'flexible',
    description: 'Choose your Team - Billed per hour',
    coreTeam: [],
    specialists: [],
    pricing: 'Custom Pricing'
  }
];

export const mockTestimonials = [
  {
    name: 'Sarah Johnson',
    role: 'CTO, TechVenture Inc',
    company: 'TechVenture Inc',
    content: 'NIVA Digital transformed our infrastructure operations. Their pods integrated seamlessly with our team and delivered exceptional results.',
    rating: 5
  },
  {
    name: 'Michael Chen',
    role: 'VP Engineering, CloudScale Solutions',
    company: 'CloudScale Solutions',
    content: 'The expertise and dedication of the NIVA team is unmatched. We reduced our cloud costs by 45% while improving performance.',
    rating: 5
  },
  {
    name: 'Emily Rodriguez',
    role: 'Head of Operations, DataFlow Systems',
    company: 'DataFlow Systems',
    content: 'Working with NIVA has been a game-changer. Their Build-Operate-Transfer model gave us exactly what we needed.',
    rating: 5
  }
];

export const mockStats = [
  { label: 'Years of Experience', value: '10+' },
  { label: 'Successful Projects', value: '500+' },
  { label: 'Expert Engineers', value: '200+' },
  { label: 'Client Satisfaction', value: '98%' }
];

export const mockTeamMembers = [
  {
    name: 'Raj Kumar',
    role: 'Founder & CEO',
    bio: 'Visionary leader with 15+ years in cloud infrastructure and delivery',
    image: null
  },
  {
    name: 'Priya Sharma',
    role: 'Head of Engineering',
    bio: 'Expert in building and scaling high-performance engineering teams',
    image: null
  },
  {
    name: 'David Miller',
    role: 'VP of Operations',
    bio: 'Specializes in operational excellence and client success strategies',
    image: null
  },
  {
    name: 'Anita Desai',
    role: 'Head of Cloud Solutions',
    bio: 'Cloud architecture expert with extensive Cloud Service Providers experience',
    image: null
  }
];

export const mockCompanyInfo = {
  name: 'NIVA Digital',
  tagline: 'Infrastructure Teams',
  description: 'NIVA Digital uniquely combines delivery, deep technical expertise, and flexible engagement to tackle core business challenges. We help growing businesses accelerate software delivery, optimize cloud infrastructure, and scale operations through AI-enabled delivery pods.',
  email: 'info@nivadigital.io',
  phone: '+1 (303) 219-0207',
  locations: [
    {
      country: 'USA',
      address: '1499 W, 120th Ave Suite 110, Westminster, CO 80234',
      city: 'Colorado'
    },
    {
      country: 'India',
      address: '#235, 2nd floor, 13th Cross Rd, Indiranagar, Bengaluru, Karnataka 560038',
      city: 'Bengaluru'
    }
  ],
  social: {
    twitter: 'https://x.com/nivadigital',
    linkedin: 'https://www.linkedin.com/company/nivadigital/',
    instagram: 'https://www.instagram.com/nivadigitalsolutions',
    youtube: 'https://youtube.com/@nivadigitalllc'
  }
};